export default class Site
{
    public customizations;
    public data;
    public id;

    constructor(siteData)
    {
        // FIXME: Transition this to properites instead.
        this.customizations = siteData.customizations.map( c => {
            c.value = c.pivot.value ? c.pivot.value : true;
            return c;
        });

        this.data = siteData;

        this.customizations.forEach(c => {
            this[c.name] = c.value;
        });
    }
    
    get canInviteUsers() : boolean {
        return this.getCustomizationByName("CanInviteUsers") !== false;
    }
    
    get isPrivacyEnabled() : boolean {
        return this.getCustomizationByName("PrivacyEnabled") !== false;
    }

    get isTrackingLogEnabled() : boolean {
        return this.getCustomizationByName("TrackingLogEnabled") !== false;
    }

    get invitesPerUser() : number {
        return parseInt(this.getCustomizationValueByName("InvitesPerUser", 0));
    }

    get minimumPasswordLength() : number {
        return parseInt(this.getCustomizationValueByName("MinimumPasswordLength", 9));
    }

    get maximumPasswordLength() : number {
        return parseInt(this.getCustomizationValueByName("MaximumPasswordLength", 64));
    }

    get isWorkperksExpress(): boolean {
        return this.data.type_id === 7;
    }

    public getCustomizationByName(name: string) {
        let customization: any = false;

        this.customizations.forEach( c => {
            if(c.name === name) {
                customization = c;
                return true;
            }
        });

        return customization;
    }

    public has(name: string): any {
        return this.getCustomizationByName(name) !== false;
    }

    public getCustomizationValueByName(name: string, defaultValue: any = false): any {
        const customization = this.getCustomizationByName(name);

        if(customization) {
            return customization.value;
        }

        return defaultValue;
    }

    static getCurrentSite() {
        return new Site(window.s.site);
    }

}

